import { ADVISOR_OBJECT_KEY, getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from "../../sessionStorage";
import { CUSTOMER, GetCustomer } from "../Product/Customer/Utilities/Customer";
import accessPermission from "./Constants/AccessPermission";

const Permissions = [
  {
    permission: {
      FA: accessPermission.viewUpdatePermission,
      Ops: accessPermission.viewPermission,
      Admin: accessPermission.viewUpdatePermission,
    },
    key: "Home",
  },
  {
    permission: {
      FA: accessPermission.viewUpdatePermission,
      Ops: accessPermission.viewPermission,
      Admin: accessPermission.viewUpdatePermission,
    },
    key: "ActivityCenter",
  },
  {
    permission: {
      FA: accessPermission.viewUpdatePermission,
      Ops: accessPermission.viewPermission,
      Admin: accessPermission.viewUpdatePermission,
    },
    key: "Products",
  },
  {
    permission: {
      FA: accessPermission.viewUpdatePermission,
      Ops: accessPermission.viewPermission,
      Admin: accessPermission.viewUpdatePermission,
    },
    key: "Landing",
  },
  {
    permission: {
      FA: accessPermission.viewUpdatePermission,
      Ops: accessPermission.viewPermission,
      Admin: accessPermission.viewUpdatePermission,
    },
    key: "illustration-submission",
  },
  {
    permission: {
      FA: accessPermission.viewUpdatePermission,
      Ops: accessPermission.viewPermission,
      Admin: accessPermission.viewUpdatePermission,
    },
    key: "drop-ticket",
  },
  {
    permission: {
      FA: accessPermission.viewUpdatePermission,
      Ops: accessPermission.viewPermission,
      Admin: accessPermission.viewUpdatePermission,
    },
    key: "case-view",
  },
];

const navDenyPermissions = {
  "Resource Center": ["RCSA", "CSA", "CRU", "Ops", "ISS"],
  Campaigns: ["RCSA", "CSA", "CRU", "Ops", "ISS"],
  "Insurance Tools": ["RCSA", "CSA", "WGE"],
};

const ROUTES_DISABLED_BY_CUSTOMER = {
  Products: [CUSTOMER.ALL_STATE],
};

// Disable route access for specific customers
const hasCustomerAccessToRoute = (routeKey) => {
  if (ROUTES_DISABLED_BY_CUSTOMER[routeKey]) {
    const restrictedCustomers = ROUTES_DISABLED_BY_CUSTOMER[routeKey];

    return !restrictedCustomers.includes(GetCustomer());
  }

  return true;
};

const getPermission = (userRole, key = null) => {
  const url = window.location.pathname.split("/");
  const permissionKey = key === null ? url : key;
  const data = Permissions.find((element) => permissionKey.includes(element.key));
  if (data) {
    return data.permission[`${userRole}`];
  }

  return accessPermission.notAuthorizedPermission;
};

const checkHiddenFields = (userRole, key) => {
  const permission = getPermission(userRole, key);

  return permission === accessPermission.notAuthorizedPermission;
};

const checkDisabledFields = (key) => {
  const advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
  const role = advisorObj && advisorObj.role;
  const permission = getPermission(role, key);

  return permission === accessPermission.viewPermission;
};

const getNavLinkPermission = (userRole, navLink) => {
  const rolesToDeny = navDenyPermissions[navLink];
  let isHidden = false;
  if (rolesToDeny) {
    const hasRole = rolesToDeny.find((navLink) => navLink === userRole);
    if (hasRole) {
      isHidden = true;
    }
  }
  // Hide the Products navigation link from the sidebar for Allstate customer.
  if (GetCustomer() === CUSTOMER.ALL_STATE && navLink === "Products") {
    isHidden = true;
  }

  return isHidden;
};

const checkPermission = (value, account) => {
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY) || account;

  return accountObj && accountObj.account && accountObj.account.settings
    ? accountObj.account.settings[value] !== null
      ? accountObj.account.settings[value]
      : PermissionData[value]
    : PermissionData[value];
};

const checkAdvisorPermission = (value) => {
  const advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);

  return advisorObj && advisorObj[value] !== null ? advisorObj[value] : AdvisorPermissionData[value];
};

export { checkHiddenFields, getPermission, getNavLinkPermission, checkDisabledFields, checkPermission, checkAdvisorPermission, hasCustomerAccessToRoute };

const AdvisorPermissionData = {
  enableSearchByInsured: false,
  enableSearchByFinancialAdvisor: false,
};
const PermissionData = {
  enableNeedsAnalysis: false,
  enablePolicyReview: false,
  enableTermConversion: false,
  enableResourceCenter: true,
  enableRequestIllustration: true,
  enableSubmitCase: true,
  enableCaseStatusView: true,
  enableTermQuoterQuickLink: false,
  enableGULQuoterQuickLink: false,
  enableSPWLQuoterQuickLink: false,
  enableIULEstimatorQuickLink: false,
  enableULEstimatorQuickLink: false,
  enableLTCEstimatorQuickLink: false,
  enableTermCard: false,
  enableSPLCard: false,
  enableAssetBasedLTCCard: false,
  enableTraditionalLTCCard: false,
  enableWholeLifeCard: false,
  enableDisabilityCard: false,
  enableIUL: false,
  enableGUL: false,
  enableUL: false,
  enableVUL: false,
  enableWLSimplifiedIssue: false,
  enableWLTraditional: false,
  enableULIULNationwide: false,
  enableULIULPacificLife: false,
  enableULIULJohnHancock: false,
  enableULIULAllianz: false,
  enableULIULLincoln: false,
  enableABLTCNationwideCM: false,
  enableABLTCNationwideCMTogether: false,
  enableABLTCBrighthouse: false,
  enableABLTCLincolnMGIICA: false,
  enableABLTCLincolnMMA: false,
  enableABLTCLincolnMGFA: false,
  enableABLTCJohnHancockLifeCare: false,
  enableSaveMyQuote: true,
  enableSaveMyCase: true,
  enableSearch: true,
  enableDownloadCSV: true,
  enableDownloadExcel: true,
  enableAdvisorSearch: true,
  enableInsuredSearch: true,
  enablePermPurchasingStatistics: true,
  enablePermInsPlanningConcepts: true,
  enablePermProductSelector: true,
  enablePermPage: false,
  enablePCPPWealthAccumulation: false,
  enableFinalExpense: false,
  enableFEGerber: false,
  enableDIAssurity: false,
  enableDIAmeritas: false,
  enableDIMassMutual: false,
  enableDIPrincipal: false,
  enableTLTCMutualOfOmaha: false,
  enableCopyCase: false,
  enableInformalApplication: false,
  enableQuickQuote: false,
};



// WEBPACK FOOTER //
// ./src/components/Helpers/CheckAccess.js